'use client';

import dynamic from 'next/dynamic';
import { FooterFallbackLoading } from './FooterFallbackLoading';

export const DynamicFooter = dynamic(() => import(/* webpackChunkName: 'Footer' */ './Footer'), {
  loading: () => <FooterFallbackLoading />,
  ssr: false,
});
